import axios from "axios";
import isEmpty from "lodash/isEmpty";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

import { userLogout, userCheckLogin } from "./user";
import { clearCheckout } from "./checkout";

export const shippingAddressesLoading = () => {
	return {
		type: "SHIPPING_ADDRESSES_LOADING"
	};
};

export const shippingAddressesError = err => {
	return {
		type: "SHIPPING_ADDRESSES_ERROR",
		err
	};
};

export const shippingAddressesSuccess = payload => {
	return {
		type: "SHIPPING_ADDRESSES_SUCCESS",
		payload
	};
};

export function getShippingAddresses() {
	return (dispatch, getState) => {
		dispatch(shippingAddressesLoading());

		dispatch(userCheckLogin("customer")).then(() => {
			let token = "";
			if (getState().user.customer) token = getState().user.customer.token;

			let AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };

			return axios
				.get(REACT_APP_API_URL + "customer-shipping-addresses/", { headers: AUTH_HEADER })
				.then(response => {
					// Error explicitly set
					if (!isEmpty(response.data.errors)) {
						dispatch(shippingAddressesError(response.data.errors));

						// Error status
					} else if (!!response.data.status && response.data.status !== 200) {
						// Log user out if token expired, token, etc
						if (response.data.status === 403) {
							dispatch(clearCheckout());
							dispatch(userLogout("customer"));
						}

						dispatch(shippingAddressesError({ general: response.data.message }));

						// Success
					} else {
						dispatch(shippingAddressesSuccess(response.data));
					}
				})
				.catch(err => {
					console.log("getShippingAddresses error:", err.response.statusText);
					dispatch(shippingAddressesError({ general: err.response.statusText }));
				});
		});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/shippingAddress.js